import React from "react";
import { Resource } from "react-admin";


export const authenticatedResources = [
	<Resource name="company-users-short" intent="registration" />,
];
